// SEND-204 (Howard ruled 2026-08-14) — ONE STEP AT A TIME, SAME CANVAS.
//
// SEND-215 (Howard ruled 2026-08-14) — THE RUNNING ROW MOVED OFF THIS STRIP
// AND INTO THE RIGHT PANE. "Make the walk look like the old Annotate Photo
// screen: photo LEFT, current step's tools RIGHT." While the walk runs this
// bar is not rendered at all — the pane IS the walk. This file keeps the two
// rows that are not the walk: FINISHED (with the skipped-step naming, which
// is still read off what is DRAWN) and WALK OFF (the way back in). Nothing
// was deleted from either row.
// The walk SUGGESTS the step; it does not take the bar away. Every tool
// stays clickable while it runs, SKIP is allowed on any step that does not
// apply, and a skip is NAMED at the end rather than swallowed. Nothing here
// draws, measures, stores or prices: it selects the tool the step uses and
// says what that step writes.
import React from "react";
import { Play, Layers } from "lucide-react";

export const WalkBar = ({
  steps, walkDone, skipped, hasEvidence, onResume, onRestart,
}) => {
  // SEND-206 item 2 (Howard ruled 2026-08-14) — **THE SKIP LINE LOOKS AT
  // WHAT IS DRAWN.** A step he tapped skip on but which HAS a mark of its
  // kind on this photo is not missed, so it leaves the list entirely: the
  // banner may never say "nothing was drawn" over a mark that is sitting
  // right there. The tap is not the evidence; the photo is.
  const missedTitles = skipped
    .map((k) => steps.find((s) => s.key === k))
    .filter((s) => s && !hasEvidence(s))
    .map((s) => s.title);
  return (
    <div className="px-3 py-1.5 border-b border-[var(--border)] bg-[var(--surface-muted)]"
      data-testid="photo-takeoff-walk-bar">
      {walkDone ? (
        <div className="flex flex-wrap items-center gap-2">
          <span className="px-2 py-0.5 bg-[var(--success)] text-white text-[10px] font-bold uppercase tracking-wider"
            data-testid="photo-takeoff-walk-done">
            walk finished — {steps.length} steps
          </span>
          <span className="text-[10px] text-[var(--ink-2)] flex items-center gap-1"
            data-testid="photo-takeoff-walk-layers-hint">
            <Layers size={11} /> turn each layer off and on below to see what was missed
          </span>
          <span className="text-[10px] font-bold text-[var(--warning-text)] flex-1 min-w-[10rem]"
            data-testid="photo-takeoff-walk-skipped-note">
            {missedTitles.length
              ? `nothing drawn on this photo for: ${missedTitles.join(" · ")} — skipped, and nothing was assumed in their place`
              : "every step on this photo either has marks or was not needed"}
          </span>
          <button type="button" onClick={onRestart}
            className="px-2 py-0.5 border border-[var(--border)] text-[10px] font-bold uppercase tracking-wider hover:bg-[var(--surface)]"
            data-testid="photo-takeoff-walk-restart">
            walk it again
          </button>
        </div>
      ) : (
        <div className="flex flex-wrap items-center gap-2">
          <span className="px-2 py-0.5 border border-[var(--border)] text-[10px] font-bold uppercase tracking-wider text-[var(--muted)]"
            data-testid="photo-takeoff-walk-off">
            walk off — free bar
          </span>
          <span className="text-[10px] text-[var(--ink-2)] flex-1">
            every tool is on the bar. The walk is a suggested order, never a gate.
          </span>
          <button type="button" onClick={onResume}
            className="px-2 py-0.5 bg-[var(--ai)] text-white text-[10px] font-bold uppercase tracking-wider flex items-center gap-1"
            data-testid="photo-takeoff-walk-resume">
            <Play size={11} /> walk me through it
          </button>
        </div>
      )}
    </div>
  );
};

export default WalkBar;
